module.exports = __webpack_public_path__ + "68f6690f1323be6dbe11f845c896cfd4.jpg";